import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "hamburger-menu",
  "use": "hamburger-menu-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 16\" id=\"hamburger-menu\">\n  <rect width=\"18\" height=\"2\" />\n  <rect y=\"7\" width=\"18\" height=\"2\" />\n  <rect y=\"14\" width=\"18\" height=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/hamburger-menu.svg
// module id = null
// module chunks = 